import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=873bb138&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"
import style0 from "./ErrorAlert.vue?vue&type=style&index=0&id=873bb138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873bb138",
  null
  
)

export default component.exports